module.exports = __webpack_public_path__ + "img/Nordstrom_case_study_4.0fe8f962.png";